(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["privacy-consent"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-privacy-dialog]');
    if (link) {
      const dialog = document.getElementById(link.dataset.privacyDialog);
      if (!(dialog instanceof HTMLDialogElement)) return;
      event.preventDefault();
      const frame = dialog.querySelector('iframe[data-src]');
      if (frame) {
        frame.src = frame.dataset.src;
        frame.removeAttribute('data-src');
      }
      dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-privacy-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('dialog.privacy-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom
      ) {
        event.target.close();
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
